import React, { useEffect } from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import i18n from 'i18next'
import { useHistory } from 'react-router'
import { AtlasButton } from 'components/atlas-material/button'
import { ColorBaseMulberryBlue, ColorBaseWhite, ColorEastBay } from 'assets/styles/variables'
import { addKeyPressHandler } from 'common/util/functions'
import { useWritingStyles } from 'businesslayer/networkrequests/writingstyles/useWritingStyles'

const useStyles = makeStyles(() => ({
    StyleBannerContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '24px',
        padding: '20px 24px',
        margin: '16px 24px',
        minHeight: '102px',
        backgroundColor: '#FFF',
        border: '1px solid #E6E6E6',
        borderRadius: '12px',
        borderLeft: '4px solid transparent',
        backgroundImage:
            'linear-gradient(#FFF, #FFF), linear-gradient(180deg, #4069FE 0%, #AB48DA 50%, #BE0C1E 100%)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box'
    },
    bannerContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flex: 1,
        position: 'relative',
        zIndex: 1
    },
    bannerTextContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        flex: 1
    },
    bannerTitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '22px',
        fontWeight: 600,
        lineHeight: '28px',
        color: '#1e1e1e',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    bannerSubtitle: {
        fontFamily: 'Source Sans Pro',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        color: '#1e1e1e'
    },
    bannerText: {
        fontFamily: 'Source Sans Pro',
        fontSize: '22px',
        fontWeight: 600,
        lineHeight: '28px',
        color: '#1e1e1e',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
    },
    bannerButton: {
        textTransform: 'none',
        backgroundColor: '#465A7C',
        color: '#FFFFFF',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 600,
        padding: '8px 20px',
        borderRadius: '2px',
        minWidth: '120px',
        height: '36px',
        '&:hover': {
            backgroundColor: '#364262'
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`
        }
    },
    dismissButton: {
        textTransform: 'none',
        backgroundColor: 'transparent',
        color: '#465A7C',
        fontFamily: 'Source Sans Pro',
        fontSize: '16px',
        fontWeight: 400,
        padding: '8px 16px',
        borderRadius: '4px',
        textDecoration: 'none',
        minWidth: 'auto',
        '&:hover': {
            backgroundColor: 'transparent',
            color: '#364262',
            textDecoration: 'none'
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`
        }
    },
    bannerActionsContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        position: 'relative',
        zIndex: 1
    },
    styleLibraryLink: {
        color: ColorEastBay,
        fontWeight: 400,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
            color: '#364262'
        },
        '&:focus': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    }
}))



export const WritingStyleBanner = () => {
    const classes = useStyles()
    const history = useHistory()
    const { fetchWritingStyles } = useWritingStyles()

    useEffect(() => {
        fetchWritingStyles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box className={classes.StyleBannerContainer}>
            <Box className={classes.bannerContent}>
                <Box className={classes.bannerTextContent}>
                    <Typography className={classes.bannerTitle}>
                        {i18n.t('AI_POWERED_WRITING_STYLE_TITLE')}
                    </Typography>
                    <Typography className={classes.bannerSubtitle}>
                        {i18n.t('AI_POWERED_WRITING_STYLE_SUBTITLE')}
                    </Typography>
                </Box>
            </Box>

            <Box className={classes.bannerActionsContainer}>
                    <AtlasButton
                        className={classes.bannerButton}
                        onClick={() => history.push('/writing-style-library')}
                        onKeyPress={(e) =>
                            addKeyPressHandler(e) ? history.push('/writing-style-library') : null
                        }
                        disableRipple
                        data-analytics="MM-WritingStyle-generateStyle"
                        data-testid="WritingStyle_Generate_Button">
                           { i18n.t('VIEW_STYLE')}
                    </AtlasButton>
            </Box>
        </Box>
    )
}

export default WritingStyleBanner